// extracted by mini-css-extract-plugin
export default {"container":"Form_container__K-uLg","form-container":"Form_form-container__b1YOR","form-description":"Form_form-description__P29AN","buttonContainer":"Form_buttonContainer__bFvvN"};